controllers.controller('QuestionnaireController', [
    '$scope', '$state', '$timeout', '$location', '$ionicScrollDelegate', 'ionicToast', '$ionicLoading', '$ionicPopup', '$q',
    'LocaleService', 'API', 'AccountService', 'Storage', 'Utils', 'UserService', 'constants', 'QuestionModel', 'ErrorService', 'LoginService',
    function ($scope, $state, $timeout, $location, $ionicScrollDelegate, ionicToast, $ionicLoading, $ionicPopup, $q,
              LocaleService, API, AccountService, Storage, Utils, UserService, Const, QuestionModel, ErrorService, LoginService) {

        // LocaleService.wait().then(function (translation) {
        //     $scope.translation = translation;
        // });
        $scope.translation = LocaleService.translation;

        $scope.permit = {
            checked: false
        };
        $scope.formTemplate = [];
        $scope.formData = {};

        $scope.questionGroups = Object.assign([], Const.questionGroups);
        $scope.currentQuestionGroup = "";
        $scope.currentQuestionnaireGroup = [];
        $scope.control = {};

        $scope.scoringRules = Const['scoringRules'] || [];
        $scope.scoringRule = null;

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false,
            isProcess: false
        };

        $scope.user = UserService.get();

        $scope.navigate = function (state, params) {
            log('navigate to ', state);
            return $state.go(state, params);
        };


        $scope.modalDialogData = {};

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'QuestionnaireController',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'updateQuestionnaireFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function formatRawQuestion(questions, customerAnswers) {

            function format(question) {
                var customerAnswer = _.find(customerAnswers, {questionId: question.id}) || {};
                question.values = customerAnswer['answerIds'] || [];
                question.other = customerAnswer['other'] || "";
                return question;
            }

            return questions.map(format);
        }

        $scope.$on('$ionicView.afterEnter', function () {
            return API.questions()
                .then(function (response) {
                    $scope.questionnaire = formatRawQuestion(response.questions, response.customerAnswers)
                        .map(function (rawQuestion) {
                            return new QuestionModel(rawQuestion, $scope.translation)
                        });
                })
                .then(function () {
                    return $scope.getQuestionnariesGroup();
                });
        })

        $scope.isVisible = function (question) {
            //if no deps from parent answers
            if (question.parentAnswers.length === 0) return true;

            return $scope.questionnaire
                .filter(function (item) {
                    return question.parentAnswers.indexOf(Number(item.values['id'])) > -1
                })
                .length > 0;
        };

        $scope.getQuestionnariesGroup = function () {

            $scope.currentQuestionGroup = $scope.questionGroups.shift();

            if (!$scope.currentQuestionGroup) {
                return Const['kycCheck']
                    ? $scope.getCustomerComplianceStatus()
                    : $scope.getCustomerScoring();
            }

            $scope.currentQuestionnaireGroup = this.questionnaire
                .filter(function (question) {
                        return question.group === $scope.currentQuestionGroup
                    }
                );

            var isGroupAnswered = $scope.currentQuestionnaireGroup
                .filter(function (question) {
                        return !!Object.keys(question.values).length
                    }
                )
                .length > 0;


            if (isGroupAnswered) {
                //go to next group
                return $scope.getQuestionnariesGroup();
            }
        };

        $scope.submit = function () {
            var validationResult = Object.keys($scope.control)
                .map(function (id) {
                    return {id: id, valid: $scope.control[id].validate()}
                });

            var firstNotValid = _.find(validationResult, {valid: false});

            if (firstNotValid) {
                return scrollTo("question-" + firstNotValid.id);
            }

            var questionsToFormat = $scope.currentQuestionnaireGroup.filter(function (question) {
                return _.find(validationResult, {id: question.id.toString()})
            });

            var request = formatAnswers(questionsToFormat);

            $ionicLoading.show();
            return API.questionnaire({answers: request})
                .then(checkResponse)
                .then(function () {
                    $ionicScrollDelegate.scrollTop();
                    $ionicLoading.hide();
                    return $scope.getQuestionnariesGroup();
                });
        };

        $scope.getCustomerScoring = function () {
            $ionicLoading.show();
            return API.calcScoring()
                .then(checkResponse)
                .then(function (response) {
                    $scope.scoringRule = _.find($scope.scoringRules, {classification: response.classification});
                    $scope.user.classification = response.classification;

                    $scope.user.updateRisk()

                    if ($scope.scoringRule && $scope.scoringRule.showMessage) {
                        $ionicLoading.hide();

                        var translation = extractPopupMessage($scope.scoringRule.messageTranslationKey)
                        return $scope.showModalClassificationScoringResult($scope.translation['scoring_title'], translation);
                    }

                    // skip account creation if registration state is already 3
                    if ($scope.user.registrationState === Const.userState.questionnaire) {
                        $scope.user.classification = response.classification;
                        $ionicLoading.hide();
                        // follow cmtrading registration flow
                        if (Const['splitPersonalDetails']) {
                            return $state.go('root.app.verification-v2');
                        }
                        return $state.go('root.app.assets');
                    }

                    $scope.user.registrationState = Const.userState.questionnaire;

                    return createAccount()
                        .then(function () {
                            if (Const['defaultRoute']) {
                                return;
                            }
                            var vProvider = Const['verificationProvider'];
                            var verificationStatePath = (!vProvider || vProvider === 'internal') ? 'root.app.uploadDocuments' :
                                (vProvider === 'internal-v2') ? 'root.app.verification-v2' :
                                    (vProvider === 'sumsub') ? 'root.app.verificationSumsub' : '';

                            if (!verificationStatePath) {
                                console.warn('Unknown verification provider');
                                return;
                            }
                            return $state.go(verificationStatePath, {cache: false});
                        })
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";

                    if (error.code == "3045" || error.code == "3046") {
                        $scope.modal.textTitle = LocaleService.translation.messages["3040"]; // "registration blocked" title

                        var userName = $scope.user.firstName + ' ' + $scope.user.lastName;
                        $scope.modal.textContent = ($scope.translation.messages[error.code] || '')
                            .replace(/\%name\%/, userName)
                            .replace(/\%firstName\%/, $scope.user.firstName);

                        $scope.modal.actionText = LocaleService.translation.logout;
                        $scope.modal.back = function () {
                            $ionicLoading.show();
                            return LoginService.logout()
                                .then(function () {
                                    $ionicLoading.hide();
                                    return $state.go('welcome', {cache: false});
                                })
                        }
                    }

                    $scope.modal.state = true;
                })
        };


        $scope.getCustomerComplianceStatus = function () {
            $ionicLoading.show();

            function getComplianceStatus() {
                return API.calcScoring()
                    .then(API.complianceStatus)
                    .then(checkResponse)
                    .then(function (response) {
                        $scope.user.complianceStatus = response.ComplianceStatus;
                        $scope.user.setComplianceStatus(); //updates negative/positive
                    })
                    .catch(function (error) {
                        //if request failed - we set compliance status as rejected
                        console.warn('compliance status request failed', error);
                        $scope.user.complianceStatus = 'no kyc';
                        $scope.user.setComplianceStatus(); //updates negative/positive
                    });
            }

            return getComplianceStatus()
                .then(function () {
                    return createAccount()
                        .then(function () {
                            $ionicLoading.hide();
                            if ($scope.user.complianceStatus === 'approved') {
                                return $state.go('root.app.assets');
                            }
                            return $state.go('kycCheck', {cache: false});
                        })
                        .catch(function (error) {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                            $scope.modal.textContent = "";
                            $scope.modal.state = true;
                        });
                });
        };

        $scope.showModalScoringResult = function (title, content) {
            console.trace('showModalScoringResult')
            $scope.modalDialogData.isOpened = true;
            $scope.modalDialogData.isError = false;
            $scope.modalDialogData.title = title;
            $scope.modalDialogData.content = content;

            $scope.modalDialogData.cancelTitle = LocaleService.translation.i_do_not_accept;

            $scope.modalDialogData.okTitle = $scope.scoringRule.acceptPopup ? LocaleService.translation.i_accept : LocaleService.translation.continue;

            $scope.modalDialogData.isCheckbox = Const['acceptRiskCheckbox'];
            $scope.modalDialogData.checkboxText = 'acceptText';

            $scope.modalDialogData.onOk = function () {
                if ($scope.scoringRule.acceptPopup) {
                    API.acceptRisk({accept: 1})
                        .then(function (response) {
                            $scope.user.classification = response.classification;
                            $scope.scoringRule = _.find($scope.scoringRules, {classification: response.classification});
                            $scope.user.updateRisk();

                            if ($scope.user.liveAccountExists) {
                                return $state.go('root.app.assets');
                            }

                            $scope.user.registrationState = Const.userState.questionnaire;
                            return createAccount()
                        })
                } else {
                    $scope.user.registrationState = Const.userState.questionnaire;
                    return createAccount()
                }
            };

            if ($scope.scoringRule.acceptPopup && $scope.scoringRule.buttonsView && $scope.scoringRule.buttonsView === 'acceptCancel') {
                $scope.modalDialogData.onCancel = function () {
                    logoutUser();
                }
            }

            // TODO add buttons view with checkbox

        };

        $scope.showModalClassificationScoringResult = function (title, content) {
            console.trace('showModalClassificationScoringResult');
            $ionicLoading.hide();
            $scope.modalDialogData.isOpened = true;
            $scope.modalDialogData.isError = false;
            $scope.modalDialogData.title = title;
            $scope.modalDialogData.content = content;

            $scope.modalDialogData.cancelTitle = '';
            $scope.modalDialogData.okTitle = '';
            $scope.modalDialogData.close = true;
            $scope.modalDialogData.onCancel = function () {
                // $scope.modalDialogData.isOpened = false;
                return $state.go('root.app.assets');
            };
            $scope.modalDialogData.scope = $scope;
        };

        $scope.showModalWhenRisksDidNotAccept = function () {
            $scope.modalDialogData.isOpened = true;
            $scope.modalDialogData.isError = true;
            $scope.modalDialogData.title = $scope.translation.warning;
            $scope.modalDialogData.content = $scope.translation.risks_not_accepted;

            $scope.modalDialogData.onCancel = false;

            $scope.modalDialogData.okTitle = LocaleService.translation.i_understand;
            $scope.modalDialogData.onOk = function () {
                logoutUser();
            };
        };

        $scope.showModalWhenFirstLiveAccountCreated = function () {
            $scope.modalDialogData.isOpened = true;
            $scope.modalDialogData.isError = false;
            $scope.modalDialogData.title = $scope.translation.scoring_title;
            $scope.modalDialogData.content = $scope.translation.thanks_for_registering;

            $scope.modalDialogData.onCancel = false;

            $scope.modalDialogData.okTitle = LocaleService.translation.continue;
            $scope.modalDialogData.onOk = function () {
                $state.go('root.app.uploadDocuments');
            };
        };

        function logoutUser() {
            return LoginService.logout()
                .then(function () {
                    $ionicLoading.hide();
                    $state.go('welcome');
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $state.go('welcome');
                });
        }

        function scrollTo(anchor) {
            $location.hash(anchor);
            return $ionicScrollDelegate.anchorScroll(true);
        }

        function formatAnswers(questionnaire) {
            function formatValue(value) {
                return Number(value.id)
            }

            return questionnaire.map(function (question) {
                return {
                    questionId: question.id,
                    answerIds: Array.isArray(question.values)
                        ? question.values.map(formatValue)
                            .filter(function (value) {
                                return value > 0
                            })
                        : question.values ? [Number(question.values.id)] : [],
                    answer: question.other
                }
            })
        }

        function createAccount(rule) {
            var isLive = rule
                ? !!rule.live
                : ($scope.scoringRule ? !!$scope.scoringRule.live : true);
            var leverage = $scope.scoringRule ? $scope.scoringRule.defaultLeverage : $scope.user.leverage;
            var currency = $scope.user.baseCurrency || $scope.user.currency;
            var readOnly = rule && rule.readOnly;

            $ionicLoading.show();
            return AccountService.createAccount(isLive, currency, leverage, null, readOnly)
                .then(function (response) {
                    return AccountService.switchAccount(response.mt4Account.login, !!response.mt4Account.live)
                })
                .then(function () {
                    // create additional demo account
                    return Const['demoAccountCreateWithLive'] && AccountService.createAccount(false, currency, leverage)
                })
                .then(function () {
                    // create live account on other platforms
                    // (if configured and requested creation of live account according to scoring rules)
                    if (Const['autoAdditionalAccounts'] && isLive) {
                        var accountRequest = {
                            live: isLive,
                            leverage: leverage,
                            currency: currency
                        }
                        var requests = Storage.get('tradingPlatforms')
                            //remove default platform from all platforms
                            .filter(function (platform) {
                                return platform !== Storage.get('defaultTradingPlatform')
                            })
                            .map(function (platform) {
                                return angular.extend({}, accountRequest, {tradingPlatform: platform})
                            })
                        return $q.all(requests.map(function (accountRequest) {
                            return AccountService.createAccount(accountRequest.live, accountRequest.currency, accountRequest.leverage, accountRequest.tradingPlatform)
                        }))
                    }
                })
                .then(function () {
                    $scope.modalDialogData.isOpened = false;
                    $ionicLoading.hide();
                    return $state.go(Const['defaultRoute'] || 'root.app.assets', {cache: false})
                })

        }

        function extractPopupMessage(messageKey) {
            var userName = $scope.user.firstName + ' ' + $scope.user.lastName;
            return ($scope.translation[messageKey] || '').replace(/\%name\%/, userName).replace(/\%firstName\%/, $scope.user.firstName);
        }

        $scope.closeAndSubmit = function () {
            if ($scope.user.liveAccountExists) {
                this.modalDialogData.isOpened = false;
                return $state.go('root.app.assets');
            }
            return createAccount();
        }

        $scope.acceptRisk = function (risk) {
            this.modalDialogData.isOpened = false;

            if ($scope.user.liveAccountExists) {
                return API.acceptRisk({accept: Utils.fromBoolean(risk)})
                    .then(function () {
                        $scope.user.updateRisk();
                        return $state.go('root.app.assets');
                    });
            }

            return API.acceptRisk({accept: Utils.fromBoolean(risk)})
                .then(function () {
                    $scope.user.updateRisk();
                    // create account
                    return createAccount();
                })
                .then(function () {
                    return $state.go('root.app.assets');
                });
        }

    }
]);
